module.exports = __webpack_public_path__ + "static/media/c3_mobile.52a1335c.png";